import { faClock, faUpload } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { AISUploadForm } from ".";
import FASvgIcon from "../../FASvgIcon";
import { AlertModal } from "../../modals";

const AnnualInfoStatementDetails: React.FC = () => {
  const [showUploadFormCanvas, setShowUploadFormCanvas] = useState<boolean>(false);
  const [showCommingSoon, setshowCommingSoon] = useState<boolean>(false);
  return (
    <>
      <section>
        <div className="section-title-wrap">
          <h5>
            Annual Information Statement
            <small>
              Import your AIS JSON to fetch details like Salary, Dividend , FD & SB Interest, Sale
              of land & Building etc.
            </small>
          </h5>
          <Button
            variant="primaryDark"
            size="sm"
            onClick={() => setshowCommingSoon(true)}
            // onClick={() => setShowUploadFormCanvas(() => true)}
          >
            <FASvgIcon icon={faUpload} />
            Upload AIS
          </Button>
        </div>
      </section>
      <AISUploadForm
        showCanvas={showUploadFormCanvas}
        handleCloseBtnPress={() => {
          setShowUploadFormCanvas(() => false);
        }}
      />
      {showCommingSoon && (
        <AlertModal
          showModal={showCommingSoon}
          iconColorClass="text-warning"
          title="Coming Soon"
          message={<p></p>}
          icon={faClock}
          onYesBtnClick={() => setshowCommingSoon(false)}
          onYesBtnText="Okay"
        />
      )}
    </>
  );
};

export default AnnualInfoStatementDetails;
